/* eslint-disable */

import httpClient from '@/utils/httpClient'
import TenantsBalanceRepository from './balance'
import TenantsIncomeRepository from './income'
import TenantsTransactionsRepository from './transaction'
import TenantsFinesRepository from './fines'
import TenantsDepositRepository from './deposit'
import TenantsPaymentRepository from './payment'

class TenantsRepository extends httpClient {
   resource = '/tenants';

   async getDriverTransactionsIsOpen (params) {
     const response = await this.get(`${this.resource}/driver-transactions-is-open`, { params })
     return response
   }

   async getDriverTransactionsInModal (transactionId) {
     const response = await this.get(`${this.resource}/income/open-transaction?transactionId=${transactionId}`)
     return response ?? []
   }

   async getDriversDebts (params) {
     const response = await this.get(`${this.resource}/debts`, { params })
     return response?.driversDebts ?? []
   }

   async resetDriverPasswordById (driverID) {
     return await this.get(`${this.resource}/telegram/reset-password`, { params: { DriverID: driverID } })
   }
}

const TenantsRepositoryes = {
  index: new TenantsRepository(),
  balance: new TenantsBalanceRepository(),
  payment: new TenantsPaymentRepository(),
  income: new TenantsIncomeRepository(),
  transaction: new TenantsTransactionsRepository(),
  fines: new TenantsFinesRepository(),
  deposit: new TenantsDepositRepository()
}
export default TenantsRepositoryes
